
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"#AFAFAF","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_106_1752)"}},[_c('path',{attrs:{"d":"M13.991 3.363c-6.707 0-12.08 5.332-12.08 11.88 0 3.232 1.323 6.207 3.434 8.384-.355.522-.969 1.226-1.765 2.271-.442.523-.355 1.397.268 1.835.27.17.528.266.797.266.355 0 .796-.171 1.055-.523 0 0 1.056-1.397 1.766-2.186 1.852 1.226 4.145 1.92 6.525 1.92 2.38 0 4.673-.704 6.525-1.92.614.874 1.766 2.186 1.766 2.186.268.352.614.523 1.055.523.269 0 .528-.086.797-.266.527-.438.71-1.227.268-1.835-.796-1.045-1.41-1.749-1.765-2.271 2.12-2.186 3.435-5.152 3.435-8.383 0-6.549-5.47-11.88-12.081-11.88zM4.29 15.243c0-5.331 4.318-9.608 9.701-9.608 5.383 0 9.701 4.277 9.701 9.609s-4.318 9.609-9.701 9.609c-5.383.085-9.701-4.277-9.701-9.61z"}}),_c('path',{attrs:{"d":"M14.786 13.676V10.36a.79.79 0 00-.797-.789.79.79 0 00-.796.79v3.316a1.711 1.711 0 00-.97.96H6.583a.79.79 0 00-.797.789.79.79 0 00.797.789h5.642c.268.608.883.96 1.583.96.97 0 1.852-.789 1.852-1.835.173-.788-.269-1.397-.883-1.663h.01zM1.419 1.388C-.375 3.166-.471 6.008 1.15 7.88l6.813-6.663c-1.88-1.692-4.75-1.606-6.544.171zM20.035 1.217l6.813 6.662c1.612-1.862 1.526-4.704-.269-6.482-1.794-1.777-4.663-1.862-6.544-.18z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_106_1752"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h28v28H0z"}})])])])
          )
        }
      }
    